module.exports = __webpack_public_path__ + "assets/img/ppt.b154e27b.png";